import ArbitratorSingleDispute from "./ArbitratorSingleDispute";

export default ArbitratorSingleDispute;
